<template>
  <div v-if="!$store.getters.gameType" class="loading" />
  <div v-else class="content">
    <div class="my-bet">
      <ul class="tabs">
        <li :class="{'active': beforeDay === 0}" @click="switchDay(0)">
          {{ $t("Bao.today") }}
        </li>
        <li :class="{'active': beforeDay === 1}" @click="switchDay(1)">
          {{ $t("Bao.yesterday") }}
        </li>
        <li :class="{'active': beforeDay === 2}" @click="switchDay(2)">
          {{ $t("Bao.2_days_ago") }}
        </li>
        <li :class="{'active': beforeDay === 3}" @click="switchDay(3)">
          {{ $t("Bao.3_days_ago") }}
        </li>
        <li :class="{'active': beforeDay === 4}" @click="switchDay(4)">
          {{ $t("Bao.4_days_ago") }}
        </li>
        <li :class="{'active': beforeDay === 5}" @click="switchDay(5)">
          {{ $t("Bao.5_days_ago") }}
        </li>
        <li :class="{'active': beforeDay === 6}" @click="switchDay(6)">
          {{ $t("Bao.6_days_ago") }}
        </li>
        <li :class="{'active': beforeDay === 7}" @click="switchDay(7)">
          {{ $t("Bao.7_days_ago") }}
        </li>
      </ul>
      <div class="tabs-mobile" @click="showAccountQuick = true">
        <span>{{ selectedDay }}<i /></span>
      </div>
      <div class="tabs-mobile-list" :class="{ 'active': showAccountQuick }">
        <div class="tabs-mobile-header">
          <span @click="closeAccountQuick()">Done</span>
        </div>
        <ul>
          <li>
            <a @click="switchDay(0, $t('Bao.today'))">{{ $t("Bao.today") }}</a>
          </li>

          <li>
            <a @click="switchDay(1, $t('Bao.yesterday'))">{{ $t("Bao.yesterday") }}</a>
          </li>

          <li>
            <a @click="switchDay(2, $t('Bao.2_days_ago'))">{{ $t("Bao.2_days_ago") }}</a>
          </li>

          <li>
            <a @click="switchDay(3, $t('Bao.3_days_ago'))">{{ $t("Bao.3_days_ago") }}</a>
          </li>

          <li>
            <a @click="switchDay(4, $t('Bao.4_days_ago'))">{{ $t("Bao.4_days_ago") }}</a>
          </li>

          <li>
            <a @click="switchDay(5, $t('Bao.5_days_ago'))">{{ $t("Bao.5_days_ago") }}</a>
          </li>

          <li>
            <a @click="switchDay(6, $t('Bao.6_days_ago'))">{{ $t("Bao.6_days_ago") }}</a>
          </li>

          <li>
            <a @click="switchDay(7, $t('Bao.7_days_ago'))">{{ $t("Bao.7_days_ago") }}</a>
          </li>
        </ul>
      </div>
      <div class="bet-list">
        <div v-if="record.length !== 0" class="bet-table">
          <table>
            <tr>
              <th>
                {{ $t("Bao.bet_time") }}
              </th>
              <th>
                {{ $t("Bao.game_finish_at") }}
              </th>
              <th>
                {{ $t("Bao.plateform_name") }}
                <br>
                {{ $t("Bao.game") }}
              </th>
              <th>
                {{ $t("Bao.wallet_type") }}
              </th>
              <th>
                {{ $t("Bao.bet_amount") }}
              </th>
              <th>
                {{ $t("Bao.win_amount") }}
              </th>
              <th>
                {{ $t("Bao.status") }}
              </th>
            </tr>
            <tr v-for="(item, key) in record" :key="key">
              <td :data-title="$t('Bao.bet_time')">
                {{ processedAndSplitDate(item.created_at)[0] }}
                <br>
                {{ processedAndSplitDate(item.created_at)[1] }}
              </td>
              <td :data-title="$t('Bao.game_finish_at')">
                <template v-if="item.updated_at">
                  {{ processedAndSplitDate(item.updated_at)[0] }}
                  <br>
                  {{ processedAndSplitDate(item.updated_at)[1] }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td :data-title="$t('Bao.plateform_name')">
                {{ item.game_provider_name }}
                <br :data-title="$t('Bao.game_name')">
                {{ item.game_name }}
              </td>
              <td :data-title="$t('Bao.wallet_type')">
                <template v-if="item.wallet_type === 'main'">
                  {{ $t("Bao.main") }}
                </template>
                <template v-if="item.wallet_type === 'bonus'">
                  {{ $t("Bao.bonus") }}
                </template>
                <template v-if="item.wallet_type === 'commission'">
                  {{ $t("Bao.margin") }}
                </template>
              </td>
              <td :data-title="$t('Bao.bet_amount')">
                {{ item.bet_amount | numberFormat }}
              </td>
              <td :data-title="$t('Bao.win_amount')">
                {{ item.win_amount | numberFormat }}
              </td>
              <td :data-title="$t('Bao.status')">
                {{ getStatusText(item.status) }}
              </td>
            </tr>
          </table>
        </div>
        <div v-if="record.length === 0 && !loading && !firstLoad" class="text-center">
          <img width="258" :src="require(`@/assets/${$store.getters.currentTheme}/images/no-data.png`)" alt="">
          <h5>{{ $t('Bao.no_relevant_data_records') }}</h5>
          <span>{{ $t('Bao.search_results_are_empty') }}</span>
        </div>
        <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
      </div>
      <div class="bet-list-mobile">
        <div v-if="record.length === 0 && !loading && !firstLoad">
          <table>
            <tbody>
              <tr>
                <th colspan="9" class="text-center">
                  <i>
                    <img class="no-data-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/no-data.png`)" alt="">
                  </i>
                  <h5>{{ $t('Bao.no_relevant_data_records') }}</h5>
                  <span>{{ $t('Bao.search_results_are_empty') }}</span>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-for="(item, key) in record" :key="key" class="bet-table">
          <table>
            <tbody>
              <tr>
                <th>{{ $t('Bao.bet_time') }}</th>
                <td>{{ item.created_at | fullDateTimeFormat }}</td>
              </tr>
              <tr>
                <th>{{ $t('Bao.game_finish_at') }}</th>
                <td>
                  <template v-if="item.updated_at">
                    {{ item.updated_at | fullDateTimeFormat }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </td>
              </tr>
              <tr>
                <th>{{ $t('Bao.plateform_name') }}</th>
                <td>{{ item.game_provider_name }}</td>
              </tr>
              <tr>
                <th>{{ $t('Bao.game_name') }}</th>
                <td>{{ item.game_name }}</td>
              </tr>
              <tr>
                <th>{{ $t('Bao.wallet_type') }}</th>
                <td>
                  <template v-if="item.wallet_type === 'main'">
                    {{ $t("Bao.main") }}
                  </template>
                  <template v-if="item.wallet_type === 'bonus'">
                    {{ $t("Bao.bonus") }}
                  </template>
                  <template v-if="item.wallet_type === 'commission'">
                    {{ $t("Bao.margin") }}
                  </template>
                </td>
              </tr>
              <tr>
                <th>{{ $t('Bao.bet_amount') }}</th>
                <td>{{ item.bet_amount | numberFormat }}</td>
              </tr>
              <tr>
                <th>{{ $t('Bao.win_amount') }}</th>
                <td>{{ item.win_amount | numberFormat }}</td>
              </tr>
              <tr>
                <th>{{ $t('Bao.status') }}</th>
                <td>{{ getStatusText(item.status) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { gameBetRecord } from '@/api/game'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'

export default {
  components: {
    ScrollLoader
  },
  data() {
    return {
      status: 'all',
      beforeDay: 0,
      record: [],
      page: 1,
      pageSize: 50,
      enableAutoLoad: true,
      loading: false,
      firstLoad: true,
      selectedDay: this.$i18n.t('Bao.today'),
      showAccountQuick: false
    }
  },
  computed: {
    getStatusText() {
      return (status) => {
        switch (status) {
          case '1':
            return this.$t('Bao.bet_success')
          case '0':
            return this.$t('Bao.bet_pending')
          case '-1':
            return this.$t('Bao.bet_failed')
          default:
            return '-'
        }
      }
    }
  },
  created() {
    this.oneQuery()
  },
  methods: {
    async query() {
      if (this.loading) return
      this.loading = true
      this.firstLoad = false
      const queryObj = {
        'startDate': Math.floor(moment().subtract(this.beforeDay, 'days').startOf('day').valueOf() / 1000),
        'endDate': Math.floor(moment().subtract(this.beforeDay, 'days').endOf('day').valueOf() / 1000),
        'page': this.page,
        'page_size': this.pageSize
      }
      if (this.status !== 'all') {
        queryObj.status = this.status
      }

      const res = await gameBetRecord(queryObj)
      this.checkRecord(res.data.data.list)

      // 目前的資料上限 (每次 scroll-loader 觸發時，允許的最大數量)
      const maxRecordsAllowed = 50 * this.page

      if (res.data.data.list.length < this.pageSize) {
        // **條件 1:** API 回傳數據 < pageSize，表示資料已撈完，停止自動載入
        this.enableAutoLoad = false
      } else if (this.record.length >= maxRecordsAllowed) {
        // **條件 2:** 如果目前記錄已達當前允許的最大數量，停止載入
        this.enableAutoLoad = false
      } else {
        // **條件 3:** 否則繼續下一頁
        this.page += 1
        this.enableAutoLoad = true
      }

      this.loading = false
      this.firstLoad = false

      if (this.enableAutoLoad && res.data.data.list.length === this.pageSize) this.query()
    },
    checkRecord(list) {
      const newRecordsMap = new Map()

      list.forEach(record => {
        const roundId = record.round_id && record.round_id.trim() ? record.round_id : null

        if (roundId) {
          if (!newRecordsMap.has(roundId)) {
            // 如果這個 round_id 還沒出現，則新增
            newRecordsMap.set(roundId, {
              ...record,
              bet_amount: record.action_type === 'bet' ? record.amount : 0,
              win_amount: record.action_type === 'win' ? record.amount : 0
            })
          } else {
            // 如果 round_id 已存在，則合併 bet_amount 和 win_amount
            const existingRecord = newRecordsMap.get(roundId)
            if (record.action_type === 'bet') {
              existingRecord.bet_amount = record.amount
            } else if (record.action_type === 'win') {
              existingRecord.win_amount = record.amount
            }
          }
        } else {
          // round_id 為 null 或空值的，單獨存放
          newRecordsMap.set(Symbol(), {
            ...record,
            bet_amount: record.action_type === 'bet' ? record.amount : 0,
            win_amount: record.action_type === 'win' ? record.amount : 0
          })
        }
      })

      // 轉換成陣列
      const newRecords = Array.from(newRecordsMap.values())

      // 確保新資料不會重複舊資料
      const existingRoundIds = new Set(this.record.map(record => record.round_id).filter(Boolean))

      const filteredNewRecords = newRecords.filter(record => {
        if (record.round_id && existingRoundIds.has(record.round_id)) {
          return false // 過濾掉重複的 round_id
        }
        existingRoundIds.add(record.round_id)
        return true
      })

      // 新資料追加到舊資料後面
      this.record = [...this.record, ...filteredNewRecords]
    },
    oneQuery() {
      this.enableAutoLoad = true
      this.page = 1
      this.record = []
      this.query()
    },
    switchDay(beforeDay, dayName) {
      this.beforeDay = beforeDay
      this.selectedDay = dayName
      this.closeAccountQuick()
      this.oneQuery()
    },
    closeAccountQuick() {
      this.showAccountQuick = false
      this.$store.state.app.hideMobileNav = false
    },
    processedAndSplitDate(formattedTime) {
      const formattedValue = this.$options.filters.fullDateTimeFormat(formattedTime)
      const dataParts = formattedValue.split(' ')
      return dataParts
    }
  }
}
</script>

<style>
.text-center, .text-center h5 {
  text-align:center!important
}
.no-data-img {
  display: inline
}
</style>
